import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ModalMessageComponent } from 'src/app/components/common/modalmessage/modalmessage.component';
import { Idioma } from 'src/app/interfaces/idioma';
import { JwtResponse } from 'src/app/interfaces/jwt';
import { IdiomaService } from 'src/app/services/idioma/idioma.service';

@Component({
  selector: 'app-language-candidate',
  templateUrl: './language-candidate.component.html',
  styleUrls: ['./language-candidate.component.scss']
})
export class LanguageCandidateComponent implements OnInit {

  usuario: JwtResponse;
  idiomas: Idioma[];
  idiomaCandidato: Idioma;
  mostrarEdicion: boolean;
  noPagina: number;
  formIdi: FormGroup;
  editarIdioma: boolean;
  mostrarIdioma: boolean;

  constructor(private idiomaService: IdiomaService,private modalService: NgbModal, private formBuilder: FormBuilder) {
    this.usuario = JSON.parse(localStorage.getItem('currentUser'));
    this.idiomaCandidato = {} as Idioma;
    this.editarIdioma = false;
    this.mostrarIdioma = false;
  }

  ngOnInit() {
    this.noPagina = 1;
    this.cargarIdiomasPorIdCandidato();
    this.crearFormularioIdioma();
  }

  crearFormularioIdioma(): void {
    this.formIdi = this.formBuilder.group({
      nombre: [null, Validators.required],
      nivel: [null, [Validators.required, Validators.maxLength(3), Validators.pattern(/^([0-9])*$/)]]
    });
  }

  validarIdioma(): void {
    if(this.idiomaCandidato && this.idiomaCandidato.idIdioma){
      this.actualizarIdiomaCandidato();
    }else{
      if(this.formIdi.valid){
        this.registrarIdiomaCandidato();
      }
    }
  }

  async cargarIdiomasPorIdCandidato(){
    try {
      const response = await this.idiomaService.obtenerIdiomasPorIdCandidato(this.usuario.user.idUsuario);
      this.idiomas = response.data
      if(this.idiomas.length == 0){
        this.mostrarEdicion = true;
      }
    } catch (error) {
      console.error("Error al cargar los datos de idiomas", error);
    }
  }

  registrarIdiomaCandidato(): void {
    const idioma: Idioma = {
      idIdioma: null,
      nombre: this.formIdi.get('nombre').value,
      nivel: this.formIdi.get('nivel').value
    };

    this.idiomaService.registrarIdioma(this.usuario.user.idUsuario, idioma).pipe(
      catchError(error => {
        let mensajeError = '';
        if (error.status === 0) {
          mensajeError = 'Error: se ha producido un error: ' + error.error + '\n';
          mensajeError += `Http error: ${error.message}`;
          console.error('se ha producido un error:', error.error);
        } else {
          mensajeError = `Error (código ${error.error.statusCode}): mensaje de error: ${error.error.message}.\n`;
          mensajeError += `Http error: ${error.message}`;
          console.error(`Error en el API ${error.status}, cuerpo: `, error.error);
        }
        this.abrirModalMessage("Error", mensajeError);
        return throwError(mensajeError);
      })
    ).subscribe(result => {
      if (result.success) {
        this.ngOnInit();
        this.mostrarEdicion = false;
        this.abrirModalMessage("Éxito", "Se ha registrado correctamente.");
      } else {
        this.abrirModalMessage("Error", "No se ha registrado correctamente " + result.messageError);
        console.error('Error al registrar el idioma del candidato: ', result.messageError);
      }
    });
  }

  actualizarIdiomaCandidato(): void {
    const idioma: Idioma = {
      idIdioma: this.idiomaCandidato.idIdioma,
      nombre: this.formIdi.get('nombre').value || this.idiomaCandidato.nombre,
      nivel: this.formIdi.get('nivel').value || this.idiomaCandidato.nivel
    };

    this.idiomaService.actualizarIdioma(idioma).pipe(
      catchError(error => {
        let mensajeError = '';
        if (error.status === 0) {
          mensajeError = 'Error: se ha producido un error: ' + error.error + '\n';
          mensajeError += `Http error: ${error.message}`;
          console.error('se ha producido un error:', error.error);
        } else {
          mensajeError = `Error (código ${error.error.statusCode}): mensaje de error: ${error.error.message}.\n`;
          mensajeError += `Http error: ${error.message}`;
          console.error(`Error en el API ${error.status}, cuerpo: `, error.error);
        }
        this.abrirModalMessage("Error", mensajeError);
        return throwError(mensajeError);
      })
    ).subscribe(result => {
      if (result.success) {
        this.ngOnInit();
        this.mostrarEdicion = false;
        this.idiomaCandidato = {} as Idioma;
        this.abrirModalMessage("Éxito", "Se ha actualizado correctamente.");
      } else {
        this.abrirModalMessage("Error", "No se ha actualizado correctamente " + result.messageError);
        console.error('Error al actualizar el idioma del candidato: ', result.messageError);
      }
    });
  }

  eliminarIdioma(idIdioma: number):void {
    if(this.usuario && this.usuario.user.idUsuario && idIdioma){
      this.idiomaService.eliminarIdiomaPorId(this.usuario.user.idUsuario, idIdioma).pipe(
        catchError(error => {
          let mensajeError = '';
          if (error.status === 0) {
            mensajeError = 'Error: se ha producido un error: ' + error.error + '\n';
            mensajeError += `Http error: ${error.message}`;
            console.error('se ha producido un error:', error.error);
          } else {
            mensajeError = `Error (código ${error.error.statusCode}): mensaje de error: ${error.error.message}.\n`;
            mensajeError += `Http error: ${error.message}`;
            console.error(`Error en el API ${error.status}, cuerpo: `, error.error);
          }
          this.abrirModalMessage("Error", mensajeError);
          return throwError(mensajeError);
        })
      ).subscribe(result => {
        if (result.success) {
          this.ngOnInit();
          this.mostrarEdicion = false;
          this.abrirModalMessage("Éxito", "Se ha eliminado correctamente.");
        } else {
          this.abrirModalMessage("Error", "No se ha eliminado correctamente " + result.messageError);
          console.error('Error al eliminar el idioma del candidato: ', result.messageError);
        }
      });
    }
  }

  habilitarEdicion(idioma: Idioma): void{
    this.idiomaCandidato = {} as Idioma;
    if(idioma){
      this.mostrarEdicion = true;
      this.editarIdioma = true;
      this.idiomaCandidato = idioma;
    }
  }

  mostrarEdicionIdioma(): void {
    this.mostrarEdicion = true;
    this.editarIdioma = false;
    this.idiomaCandidato = {} as Idioma;
  }

  abrirModalMessage(modalTitle: string, modalMessage: string) {
    const modalRef = this.modalService.open(ModalMessageComponent, { centered: true });
    modalRef.componentInstance.modalTitle = modalTitle;
    modalRef.componentInstance.modalMessage = modalMessage;
  }

  mostrarIdiomaData(): void {
    this.mostrarIdioma = !this.mostrarIdioma;
  }

  cerrarIdiomaData(): void {
    this.mostrarIdioma = false;
  }
}
